import { render } from "./IntroCardsCreator.vue?vue&type=template&id=cfdb3fa6&bindings={\"cards\":\"data\"}"
import script from "./IntroCardsCreator.vue?vue&type=script&lang=js"
export * from "./IntroCardsCreator.vue?vue&type=script&lang=js"
script.render = render

export default script